import { render, staticRenderFns } from "./JbbfIconWrapper.vue?vue&type=template&id=8fdf46d8&scoped=true&"
import script from "./JbbfIconWrapper.vue?vue&type=script&lang=js&"
export * from "./JbbfIconWrapper.vue?vue&type=script&lang=js&"
import style0 from "./JbbfIconWrapper.vue?vue&type=style&index=0&id=8fdf46d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdf46d8",
  null
  
)

export default component.exports